export const CHECKOUT_STEPS = {
  ACCOUNT: "account",
  ADDRESS: "address",
  SHIPPING: "shipping",
};

export const STEPS = [
  { name: "01_Login", step: CHECKOUT_STEPS.ACCOUNT },
  { name: "02_Address", step: CHECKOUT_STEPS.ADDRESS },
  { name: "03_Payment", step: CHECKOUT_STEPS.SHIPPING },
];

export const CHECKOUT_BREADCRUMB = [
  { label: "Home", url: "/" },
  { label: "Checkout", url: "/cart" },
];

export const ADDRESS_FORM_FIELDS = [
  {
    id: 1,
    name: "firstName",
    label: "First_Name",
    placeholder: "Eg_John",
    type: "input",
  },
  {
    id: 2,
    name: "lastName",
    label: "Last_Name",
    placeholder: "Eg_Doe",
    type: "input",
  },
  {
    id: 3,
    name: "email",
    label: "Email_Address",
    placeholder: "Eg_You_@_Example_com",
    type: "input",
  },
  {
    id: 4,
    name: "phoneNumber",
    label: "Phone_Number",
    placeholder: "Eg_55_123_4567",
    type: "input",
  },
  {
    id: 8,
    name: "street",
    label: "Street",
    placeholder: "Eg_Al-Bat'ha",
    type: "input",
  },
  {
    id: 9,
    name: "line1",
    label: "Address",
    placeholder: "Eg_Apartment_12_Building_5",
    type: "input",
  },
  {
    id: 6,
    name: "city",
    label: "City",
    placeholder: "Eg_Dammam_City",
    type: "select",
  },
  {
    id: 7,
    name: "zipCode",
    label: "Postal_Code",
    placeholder: "Eg_31441",
    type: "input",
  },
  {
    id: 5,
    name: "country",
    label: "Country",
    placeholder: "Country",
    readOnly: true,
    disabled: true,
    type: "input",
  },
];
